const shadows = [
  'none',
  ...new Array(24).fill('0px 8px 8px rgba(102, 102, 102, 0.05)'),
]

export default shadows
